import api from "./api";

/**
 * GET /api/paddle/customers/{customerId}/transactions
 */
export const listPaddleTransactions = async (customerId, auth) => {
  return await api
    .get(`/api/paddle/customers/${encodeURIComponent(customerId)}/transactions`, {
      headers: {
        Authorization: "Bearer " + auth.access_token,
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.log(error);
      return false;
    });
};

/**
 * GET /api/paddle/customers/{customerId}/invoices?includePdf=true|false
 * includePdf: si true, le backend tente de récupérer un lien PDF temporaire par transaction
 */
export const listPaddleInvoices = async (customerId, auth, includePdf = true) => {
  return await api
    .get(
      `/api/paddle/customers/${encodeURIComponent(customerId)}/invoices?includePdf=${includePdf ? "true" : "false"}`,
      {
        headers: {
          Authorization: "Bearer " + auth.access_token,
        },
      }
    )
    .then((res) => res.data)
    .catch((error) => {
      console.log(error);
      return false;
    });
};

/**
 * POST /api/paddle/transactions/{transactionId}/refund
 * Full refund:
 *   { type: "full", reason: "customer_request" }
 *
 * Partial refund:
 *   { type: "partial", reason: "goodwill", items: [{ itemId: "txnitm_...", amount: "100" }] }
 */
export const refundPaddleTransaction = async (transactionId, auth, payload) => {
  // payload exemple:
  // { type: "full", reason: "customer_request" }
  // ou
  // { type: "partial", reason: "goodwill", items: [{ itemId, amount }] }

  return await api
    .post(`/api/paddle/transactions/${encodeURIComponent(transactionId)}/refund`, payload, {
      headers: {
        Authorization: "Bearer " + auth.access_token,
      },
    })
    .then((res) => res.data)
    .catch((error) => {
      console.log(error);
      return false;
    });
};